module.exports = __webpack_public_path__ + "02_glasses_brown.a8dac7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/02_glasses_brown.png
// module id = GGvB
// module chunks = 0